import styled, { keyframes } from "styled-components";

import { NavLink } from "react-router";
import "../../../../GlobalStyles/Font.css";

export const NameUser = styled.h1`
  font-size: 20px;
  line-height: 1.2;
  font-family: "Exo2 Light";
  color: #000;

  @media (min-width: 744px) {
    display: flex;
    gap: 10px;
    font-size: 24px;
    line-height: 1.1;
  }

  @media (min-width: 1440px) {
    font-size: 36px;
    line-height: 1.19;
  }
`;

export const NicNameUserColor = styled.span`
  color: #1ac63f;
`;

export const AvatarUser = styled.img`
  width: 61px;
  height: 61px;
  border-radius: 50%;

  @media (min-width: 744px) {
    width: 90px;
    height: 90px;
  }

  @media (min-width: 1024px) {
    width: 99px;
    height: 99px;
  }

  @media (min-width: 1440px) {
    width: 95px;
    height: 95px;
  }
`;

// Mobile Header

const slideIn = keyframes`
  from {
    transform: translateY(100%);
    transition: transform 450ms cubic-bezier(0.61, 0, 0.51, 1);
  }
  to {
    transform: translateY(0%);
    transition: transform 450ms cubic-bezier(0.61, 0, 0.51, 1);
  }
`;

const slideOut = keyframes`
  from {
    transform: translateY(0%);
    transition: transform 350ms cubic-bezier(0.61, 0, 0.51, 1);
  }
  to {
    transform: translateY(100%);
    transition: transform 350ms cubic-bezier(0.61, 0, 0.51, 1);
  }
`;

export const PrivateHeaderContainer = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  transition: opacity 450ms ease, background 450ms ease;
  z-index: 2;

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #093d6c;
  }

  &.menu-active.active {
    transform: translateY(0%);
    animation: ${slideIn} 450ms cubic-bezier(0.61, 0, 0.51, 1);
  }

  &.menu-active {
    transform: translateY(100%);
    animation: ${slideOut} 350ms cubic-bezier(0.61, 0, 0.51, 1);
  }

  @media (min-width: 1024px) {
    background: transparent;
    position: relative;
    height: 0%;
  }
`;

export const Backdrop = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(15px);
  background: rgba(217, 217, 217, 0.7);
  z-index: 1;

  @media (min-width: 1024px) {
    display: none;
  }
`;

export const MobileContainer = styled.div`
  max-width: 100%;
  display: flex;
  padding: 16px 16px 0;

  @media (min-width: 1024px) {
    display: none;
    padding: 24px 24px 0;
  }

  @media (min-width: 1440px) {
    max-width: 1024px;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const MenuContent = styled.div`
  position: relative;
  z-index: 1;

  @media (min-width: 1024px) {
    z-index: 0;
  }
`;

export const MobileHeaderContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (min-width: 1024px) {
    height: 99px;
  }
`;

export const MenuButton = styled.button`
  width: 46px;
  height: 46px;
  background: #1ac63f;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 428px) {
    width: 53px;
    height: 53px;
  }

  @media (min-width: 744px) {
    width: 80px;
    height: 80px;
  }
`;

export const MenuButtonHeader = styled.button`
  width: 46px;
  height: 46px;
  background: #1ac63f;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 428px) {
    width: 53px;
    height: 53px;
  }

  @media (min-width: 744px) {
    width: 80px;
    height: 80px;
  }

  @media (min-width: 1024px) {
    display: none;
  }
`;

export const ContainerUserData = styled.div`
  width: 100%;
  height: 163px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: #fff;

  @media (min-width: 744px) {
    height: 246px;
  }

  @media (min-width: 1024px) {
    width: 467px;
    height: 0px;
    display: none;
  }

  @media (min-width: 1440px) {
    width: 515px;
  }
`;

export const HeaderMobileMenu = styled.div`
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;

  @media (min-width: 1024px) {
    display: none;
  }
`;

export const LogoSafeTasker = styled(NavLink)`
  text-decoration: none;
`;

export const MenuData = styled.div`
  max-width: 100%;
  display: flex;
  align-items: center;
  gap: 20px;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: 744px) {
    max-width: 377px;
    gap: 30px;
  }

  @media (min-width: 1024px) {
    display: none;
  }
`;

export const MenuDataDesktop = styled.div`
  display: none;

  @media (min-width: 1024px) {
    max-width: 976px;
    display: flex;
    justify-content: space-between;
    gap: 20px;
    align-items: center;
    margin-left: 0px;
    margin-right: 0px;
  }

  @media (min-width: 1440px) {
    gap: 30px;
  }
`;

// Icons

export const SettingUserIcon = styled.svg`
  width: 40px;
  height: 40px;
  fill: #000;

  @media (min-width: 744px) {
    width: 50px;
    height: 50px;
  }

  @media (min-width: 1024px) {
    width: 65px;
    height: 65px;
  }
`;

export const ContainerPrivateHeaderDesktop = styled.div`
  display: none;
  @media (min-width: 1024px) {
    max-width: 976px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 24px 0;
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: 1440px) {
    max-width: 1392px;
    padding: 24px 24px 0;
    margin-left: auto;
    margin-right: auto;
  }
`;
